import {
  getManageCodesData,
  dataByIdCodes,
  dataByIdcodevalues,
  createcodes,
  createCodevalues,
  deleteCodeValues,
  deleteManageCodesData,
} from "@/http/system/manageCodes.js";

export default {
  namespaced: true,
  state: {
    codesList: [],
    CreateViewReportTemplate: {},
    CreateCodesTemplate: null,
  },
  actions: {
    async setManageCodesData({ commit }) {
      try {
        const resp = await getManageCodesData();
        commit("SET_MANAGE_CODE_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setdataByIdCodes({ commit }, id) {
      try {
        const resp = await dataByIdCodes(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setdataByIdcodevalues({ commit }, id) {
      try {
        const resp = await dataByIdcodevalues(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createcodesAction({ commit }, data) {
      try {
        const resp = await createcodes(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createCodevaluesAction({ commit }, data) {
      try {
        const resp = await createCodevalues(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteCodeValuesAction({ commit }, data) {
      try {
        const resp = await deleteCodeValues(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteManageCodesDataAction({ commit }, id) {
      try {
        const resp = await deleteManageCodesData(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_MANAGE_CODE_LIST(state, payload) {
      state.codesList = payload;
    },
    CREATE_CODES_ACTION(state, payload) {
      state.CreateCodesTemplate = payload;
    },
  },
  getters: {
    getManageListDataList(state) {
      return state.codesList;
    },
  },
};
